module.exports = __webpack_public_path__ + "img/ssc_rorgamenewtk.f65623c.png";